// Every location route's path, identical to legacy (plan §4.2: bookmarks and support links keep working), with its
// screen ID (`backoffice.` + the legacy route name; route-map.md). test/routes.test.ts holds this list equal to the
// router's tree, and the sidebar can only name a path from it.
export const SCREENS = {
  '/l/$slug': 'backoffice.dashboard',
  '/l/$slug/access-denied': 'backoffice.access-denied',
  '/l/$slug/discounts/preset': 'backoffice.discounts.preset',
  '/l/$slug/discounts/auto': 'backoffice.discounts.auto',
  '/l/$slug/discounts/price-adjustments': 'backoffice.discounts.price-adjustments',
  '/l/$slug/menu/items/{-$itemId}': 'backoffice.menu.items',
  '/l/$slug/menu/categories': 'backoffice.menu.categories',
  '/l/$slug/menu/modifiers': 'backoffice.menu.modifiers',
  '/l/$slug/menu/departments': 'backoffice.menu.departments',
  '/l/$slug/menu/display-reorder': 'backoffice.menu.reorder',
  '/l/$slug/menu/visibility': 'backoffice.menu.visibility',
  '/l/$slug/employees/list': 'backoffice.employees.list',
  '/l/$slug/employees/timecards/{-$timecardId}': 'backoffice.employees.timecards',
  '/l/$slug/employees/schedule': 'backoffice.employees.schedule',
  '/l/$slug/employees/schedule/templates': 'backoffice.employees.schedule.templates',
  '/l/$slug/employees/availability': 'backoffice.employees.availability',
  '/l/$slug/employees/time-off': 'backoffice.employees.time-off',
  '/l/$slug/employees/shift-swaps': 'backoffice.employees.shift-swaps',
  '/l/$slug/employees/shift-claims': 'backoffice.employees.shift-claims',
  '/l/$slug/employees/$employeeId': 'backoffice.employees.detail',
  '/l/$slug/settings/staff-settings/employee-roles': 'backoffice.settings.staff-settings.employee-roles',
  '/l/$slug/customers/list': 'backoffice.customers.list',
  '/l/$slug/customers/$customerId': 'backoffice.customers.detail',
  '/l/$slug/floor-plans': 'backoffice.floor-plans.list',
  '/l/$slug/order/lookup': 'backoffice.order.lookup',
  '/l/$slug/qr-table-pay/qr-codes': 'backoffice.qr-table-pay.qr-codes',
  '/l/$slug/qr-table-pay/templates': 'backoffice.qr-table-pay.templates',
  '/l/$slug/qr-table-pay/settings': 'backoffice.qr-table-pay.settings',
  '/l/$slug/online-store/info': 'backoffice.online-store.info',
  '/l/$slug/online-store/orders': 'backoffice.online-store.orders',
  '/l/$slug/online-store/hours-and-closures': 'backoffice.online-store.hours-and-closures',
  '/l/$slug/online-store/prep-times': 'backoffice.online-store.prep-time',
  '/l/$slug/online-store/banners': 'backoffice.online-store.banners',
  '/l/$slug/online-store/notifications': 'backoffice.online-store.notifications',
  '/l/$slug/online-store/voice-ordering': 'backoffice.online-store.voice-ordering',
  '/l/$slug/online-store/voice-conversations': 'backoffice.online-store.voice-conversations',
  '/l/$slug/online-store/voice-conversations/$conversationId': 'backoffice.online-store.voice-conversation-detail',
  '/l/$slug/online-store/api-keys': 'backoffice.online-store.api-keys',
  '/l/$slug/reports/sales/overview': 'backoffice.reports.sales.overview',
  '/l/$slug/reports/sales/consolidated': 'backoffice.reports.sales.consolidated',
  '/l/$slug/reports/sales/items': 'backoffice.reports.sales.items',
  '/l/$slug/reports/sales/category': 'backoffice.reports.sales.category',
  '/l/$slug/reports/sales/department': 'backoffice.reports.sales.department',
  '/l/$slug/reports/sales/employee': 'backoffice.reports.sales.employee',
  '/l/$slug/reports/sales/dining': 'backoffice.reports.sales.dining',
  '/l/$slug/reports/sales/time-segment': 'backoffice.reports.sales.time-segment',
  '/l/$slug/reports/sales/discounts': 'backoffice.reports.sales.discounts',
  '/l/$slug/reports/sales/gift-cards': 'backoffice.reports.sales.gift-cards',
  '/l/$slug/reports/sales/gift-cards/welcome': 'backoffice.reports.sales.gift-cards-welcome',
  '/l/$slug/reports/audit/drawer': 'backoffice.reports.audit.drawer',
  '/l/$slug/reports/audit/server-banks': 'backoffice.reports.audit.server-banks',
  '/l/$slug/reports/audit/drawer/$tillSessionId': 'backoffice.reports.audit.drawer.id',
  '/l/$slug/reports/audit/adjustments/voids': 'backoffice.reports.audit.adjustments.voids',
  '/l/$slug/reports/audit/adjustments/deletion': 'backoffice.reports.audit.adjustments.deletion',
  '/l/$slug/reports/audit/refunds': 'backoffice.reports.audit.refunds',
  '/l/$slug/reports/management/payroll': 'backoffice.reports.management.payroll',
  '/l/$slug/reports/management/breaks': 'backoffice.reports.management.breaks',
  '/l/$slug/settings/hardware/devices': 'backoffice.settings.hardware.devices',
  '/l/$slug/settings/location/business-profile': 'backoffice.settings.location.business-profile',
  '/l/$slug/settings/location/business-profile/business-hours': 'backoffice.settings.location.business-profile.business-hours',
  '/l/$slug/settings/location/business-profile/branding': 'backoffice.settings.location.business-profile.branding',
  '/l/$slug/settings/location/payment-configuration': 'backoffice.settings.location.payment-configuration',
  '/l/$slug/settings/location/plans-and-billing': 'backoffice.settings.location.plans-and-billing',
  '/l/$slug/settings/location/business-day': 'backoffice.settings.business-day',
  '/l/$slug/settings/staff-settings/timecards/employee-breaks': 'backoffice.settings.staff-settings.timecards.employee-breaks',
  '/l/$slug/settings/staff-settings/timecards/report-settings': 'backoffice.settings.staff-settings.timecards.report-settings',
  '/l/$slug/settings/hardware/printers': 'backoffice.settings.hardware.printers',
  '/l/$slug/profile': 'backoffice.profile',
  '/l/$slug/settings/location/users': 'backoffice.settings.location.users',
  '/l/$slug/settings/staff-settings/user-roles': 'backoffice.settings.staff-settings.user-roles',
  '/l/$slug/settings/staff-settings/scheduling': 'backoffice.settings.staff-settings.scheduling',
  '/l/$slug/settings/staff-settings/timecards/overtime': 'backoffice.settings.staff-settings.timecards.overtime',
  '/l/$slug/settings/order-checkout/pos-functions/register-settings': 'backoffice.settings.order-checkout.register-settings',
  '/l/$slug/settings/order-checkout/pos-functions/drawers': 'backoffice.settings.order-checkout.drawers',
  '/l/$slug/settings/order-checkout/pos-functions/voids': 'backoffice.settings.order-checkout.voids',
  '/l/$slug/settings/order-checkout/pos-functions/dining-options': 'backoffice.settings.order-checkout.dining-options',
  '/l/$slug/settings/order-checkout/pos-functions/tender-types': 'backoffice.settings.order-checkout.tender-types',
  '/l/$slug/settings/order-checkout/pos-functions/pacing': 'backoffice.settings.order-checkout.pacing',
  '/l/$slug/settings/order-checkout/pos-functions/id-verification': 'backoffice.settings.order-checkout.id-verification',
  '/l/$slug/settings/order-checkout/print-options': 'backoffice.settings.order-checkout.print-options',
  '/l/$slug/settings/order-checkout/tips/customer-tips': 'backoffice.settings.order-checkout.tips.customer-tips',
  '/l/$slug/settings/order-checkout/tips/staff-tips': 'backoffice.settings.order-checkout.tips.staff-tips',
  '/l/$slug/settings/reporting/time-segments': 'backoffice.settings.reporting.time-segments',
  '/l/$slug/settings/reporting/departments': 'backoffice.settings.reporting.departments',
} as const;

export type AppPath = keyof typeof SCREENS;

/** "/l/$slug/discounts/preset" with slug "the-owl-club" → "/l/the-owl-club/discounts/preset" (optional params dropped). */
export function pathFor(path: AppPath, slug: string): string {
  return path.replace('$slug', slug).replace(/\/\{-\$\w+\}$/, '');
}
